import { Button, ButtonProps, ElementProps } from '@mantine/core';
import { ReactNode } from 'react';

export function IconButton(
  props: { icon: ReactNode } & ButtonProps &
    ElementProps<'button', keyof ButtonProps>
) {
  return (
    <Button
      bg='teal.0'
      {...props}
      radius={36}
      w={40}
      p={0}
      style={{ border: 'none' }}
    >
      {props.icon}
    </Button>
  );
}
